import { render, staticRenderFns } from "./Manage_mobile_service.vue?vue&type=template&id=4fea4c88&"
import script from "./Manage_mobile_service.vue?vue&type=script&lang=js&"
export * from "./Manage_mobile_service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports